import { Link } from "react-router";
import { reviewNeighbors, STORM_VERSIONS, type StormVersion } from "./storm-landing";

/**
 * Only on the review link: says this page shows draft copy, and steps through
 * the ten versions so Roger can read each one as its ad's visitors would.
 */
export function StormReviewBar({ version }: { version: StormVersion }) {
  const { position, previous, next } = reviewNeighbors(version);
  const step = (v: StormVersion) => `/go?v=${v.slug}&review=1`;

  return (
    <div
      role="region"
      aria-label="Draft review"
      className="sticky top-0 z-10 bg-foreground px-4 py-2 text-background"
    >
      <div className="mx-auto flex max-w-xl items-center justify-between gap-3 text-sm">
        <p className="leading-tight">
          <span className="font-semibold">Draft for review</span>
          <br />
          <span className="text-background/75">
            {position > 0
              ? `Ad ${version.code}, ${position} of ${STORM_VERSIONS.length}`
              : "No ad: the default page"}
            . Ad visitors don&apos;t see drafts.
          </span>
        </p>
        <div className="flex shrink-0 gap-2">
          <Link
            to={step(previous)}
            aria-label="Previous version"
            className="rounded-md border border-background/40 px-3 py-1.5 font-semibold"
          >
            &larr;
          </Link>
          <Link
            to={step(next)}
            aria-label="Next version"
            className="rounded-md bg-primary px-3 py-1.5 font-semibold text-primary-foreground"
          >
            &rarr;
          </Link>
        </div>
      </div>
    </div>
  );
}
